export const allLanguages = [
    'en',
    'es',
    'fr',
    'de',
    'it',
    'pt',
    'ja',
    'ko',
    'zh',
    'hi',
    'bn',
    'th',
    'vi',
    'tr',
    'uk',
    'id',
    'pl',
];
//# sourceMappingURL=constants.js.map